// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container{
  display:flex;
  align-items: center;
  justify-content: space-between;
}
.l-item-brand-vline{
  position: relative;
  display: inline-block;
  width: 12px;
  height: 44px;
  margin: 4px 0 2px 4px;
  background: var(--primary);
}
.l-item-brand {
  font-size: 1.9rem !important; 
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  margin-left: 10px;
  height:40px;
}
.l-item-brand-title{
  margin-left: 10px;
  display: inline-block;
  font-family: Arial;
  font-size: 17px;
  letter-spacing: 0px;
  color:#FFFFFF;
  cursor:pointer;
  border-bottom: none;
}
.l-item-brand-title-sufix-highlighted{
  font-weight:600;
  font-style: normal;
  margin-left: 5px;
}
.nav-brand {
  display: flex;
}
.nav-right {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 20px;
}
.r-item-config {
  width:20px;
  margin-right: 30px;
}
.r-item-user {
  font-family: "Segoe UI" !important;
  font-size: var(--subheader) !important;
  color: var(--header) !important;
  background-color: var(--primary) !important;
}

a.r-item {
  color: #C1C1C1;
  padding: 0.5rem 0.15rem; }
  @media screen and (max-width: 769px-1px) {
    a.r-item a.r-item {
      color: grey; }
      a.r-item a.r-item a.r-item:hover {
        background-color: #F1F1F1; } }

.nav.has-shadow {
  /* height: 100%; */
  box-shadow: 0 0px 3px #707070; 
  background-color: #2A3A42;

}

a:-webkit-any-link {
  text-decoration: none !important;
}

a:-webkit-any-link:active {
  color: none !important;
}

/*Aspect Health*/
.aspectHealthGroup {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-left: auto;
  margin-right: 20px;
  color: white;
  font-size: var(--caption);
}
.aspectHealthTitle {
  color: white;
  font-size: var(--caption);
  font-weight: 600;
  border-right: 1px solid rgba(255,255,255,0.3);
  padding-right: 16px;
}

/* Dropdown */
.supervisor-dropdown-content {
  display: none;
  max-width: 26vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.supervisor-dropdown-content.active {
  display: grid;
  position: relative;
  border-radius: 4px;
}

#dropdown-header-menu > .MuiPopover-paper {
  width: 25vh;
}

.MuiTooltip-tooltip {
  font-size: 10px !important;
  color: #000 !important;
}

.dropdown-caret {
  position: absolute;
  left: 85%
}

li.logged-in-as-menu-item {
  white-space: normal;
}
.supervisor-empty-results {
  text-align: center;
  margin: 20px 0 35px 0;
  font-size: var(--caption);
}
`, "",{"version":3,"sources":["webpack://./src/components/App/components/Header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,uBAAuB,EAAE;EACzB;IACE;MACE,WAAW,EAAE;MACb;QACE,yBAAyB,EAAE,EAAE;;AAErC;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;;AAE3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B","sourcesContent":[".container{\n  display:flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.l-item-brand-vline{\n  position: relative;\n  display: inline-block;\n  width: 12px;\n  height: 44px;\n  margin: 4px 0 2px 4px;\n  background: var(--primary);\n}\n.l-item-brand {\n  font-size: 1.9rem !important; \n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n  margin-left: 10px;\n  height:40px;\n}\n.l-item-brand-title{\n  margin-left: 10px;\n  display: inline-block;\n  font-family: Arial;\n  font-size: 17px;\n  letter-spacing: 0px;\n  color:#FFFFFF;\n  cursor:pointer;\n  border-bottom: none;\n}\n.l-item-brand-title-sufix-highlighted{\n  font-weight:600;\n  font-style: normal;\n  margin-left: 5px;\n}\n.nav-brand {\n  display: flex;\n}\n.nav-right {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  margin-right: 20px;\n}\n.r-item-config {\n  width:20px;\n  margin-right: 30px;\n}\n.r-item-user {\n  font-family: \"Segoe UI\" !important;\n  font-size: var(--subheader) !important;\n  color: var(--header) !important;\n  background-color: var(--primary) !important;\n}\n\na.r-item {\n  color: #C1C1C1;\n  padding: 0.5rem 0.15rem; }\n  @media screen and (max-width: 769px-1px) {\n    a.r-item a.r-item {\n      color: grey; }\n      a.r-item a.r-item a.r-item:hover {\n        background-color: #F1F1F1; } }\n\n.nav.has-shadow {\n  /* height: 100%; */\n  box-shadow: 0 0px 3px #707070; \n  background-color: #2A3A42;\n\n}\n\na:-webkit-any-link {\n  text-decoration: none !important;\n}\n\na:-webkit-any-link:active {\n  color: none !important;\n}\n\n/*Aspect Health*/\n.aspectHealthGroup {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n  margin-right: 20px;\n  color: white;\n  font-size: var(--caption);\n}\n.aspectHealthTitle {\n  color: white;\n  font-size: var(--caption);\n  font-weight: 600;\n  border-right: 1px solid rgba(255,255,255,0.3);\n  padding-right: 16px;\n}\n\n/* Dropdown */\n.supervisor-dropdown-content {\n  display: none;\n  max-width: 26vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.supervisor-dropdown-content.active {\n  display: grid;\n  position: relative;\n  border-radius: 4px;\n}\n\n#dropdown-header-menu > .MuiPopover-paper {\n  width: 25vh;\n}\n\n.MuiTooltip-tooltip {\n  font-size: 10px !important;\n  color: #000 !important;\n}\n\n.dropdown-caret {\n  position: absolute;\n  left: 85%\n}\n\nli.logged-in-as-menu-item {\n  white-space: normal;\n}\n.supervisor-empty-results {\n  text-align: center;\n  margin: 20px 0 35px 0;\n  font-size: var(--caption);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
